import { makeStyles } from '@material-ui/core';
import Colors from '../../../layout/theme/utils/colors';

export default makeStyles((theme) => ({
  link: {
    color: Colors.blue,
  },
  linkIcon: {
    marginRight: theme.spacing(0.5),
  },
}));
